import React from "react";
import { Helmet } from "react-helmet";
import { request, gql } from "graphql-request";
import { REQUEST_URL } from "../../RaymonComponents/RequestUrl";

const MAIN_INFO_ABOUT = gql`
  {
    getWebsiteAboutUs {
      _id
      pictureLink
      description
      schoolName
      title
    }
  }
`;

const SEO = () => {
  const [schoolName, setSchoolName] = React.useState("");
  React.useEffect(() => {
    request(REQUEST_URL, MAIN_INFO_ABOUT).then((data) => {
      console.log("about:", data);
      if (data.getWebsiteAboutUs) {
        setSchoolName(data.getWebsiteAboutUs.schoolName);
      }
    });
  }, []);
  return (
    <div>
      <Helmet>
        <title>{`${schoolName}`}</title>
        <meta name="description" content="شرکت فنی مهندسی رایمون فناور آسیا" />
        <meta
          name="og:title"
          property="og:title"
          content="شرکت فنی مهندسی رایمون فناور آسیا"
        ></meta>
        <meta
          name="twitter:card"
          content="شرکت فنی مهندسی رایمون فناور آسیا"
        ></meta>
        {/* <link rel="canonical" href="http://www.raymon-tech.com"></link> */}
        {/* <meta
					property="og:image"
					content="https://s3.ir-thr-at1.arvanstorage.com/raymon/raymon.png"
				/> */}
      </Helmet>
    </div>
  );
};

export default SEO;
